(function(){
  function pad(n){return String(Math.max(0,n)).padStart(2,'0');}
  function start(root){
    if(!root || root.dataset.rrCountdownReady==='true') return;
    root.dataset.rrCountdownReady='true';
    var timer=root.querySelector('[data-rr-countdown]');
    if(!timer) return;
    var target=Date.parse(timer.dataset.target || '');
    if(Number.isNaN(target)) return;
    var slots={days:timer.querySelector('[data-days]'),hours:timer.querySelector('[data-hours]'),minutes:timer.querySelector('[data-minutes]'),seconds:timer.querySelector('[data-seconds]')};
    var live=timer.querySelector('[data-live]');
    var grid=timer.querySelector('[data-grid]');
    function tick(){
      var diff=target-Date.now();
      if(diff<=0){if(grid)grid.hidden=true;if(live)live.hidden=false;return false;}
      var days=Math.floor(diff/86400000); diff%=86400000;
      var hours=Math.floor(diff/3600000); diff%=3600000;
      var minutes=Math.floor(diff/60000); diff%=60000;
      var seconds=Math.floor(diff/1000);
      if(slots.days)slots.days.textContent=String(days);
      if(slots.hours)slots.hours.textContent=pad(hours);
      if(slots.minutes)slots.minutes.textContent=pad(minutes);
      if(slots.seconds)slots.seconds.textContent=pad(seconds);
      return true;
    }
    tick();
    var interval=setInterval(function(){if(!tick())clearInterval(interval);},1000);
  }
  function removeEmptySlates(){document.querySelectorAll('.rr-empty-collection').forEach(function(el){el.remove();});}
  function boot(){document.querySelectorAll('[data-rr-founders]').forEach(start);removeEmptySlates();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',function(e){var root=e.target.querySelector('[data-rr-founders]') || (e.target.matches&&e.target.matches('[data-rr-founders]')?e.target:null);start(root);removeEmptySlates();});
})();
